import { Reveal, Eyebrow } from "./Reveal";

const ITEMS = [
  {
    label: "Your number",
    big: "Stays put",
    body: "It stays on your trucks and on Google. Calls you don't pick up are passed to a second number, and that number sends the text. Nothing to reprint, nothing to repaint.",
    wide: true,
  },
  {
    label: "Your customers",
    big: "Talk to you",
    body: "Only you. Nobody answers your phone for you — the caller gets a text, and the conversation is yours.",
  },
  {
    label: "Speed",
    big: "About a minute",
    body: "From the missed call to the text landing. Fast enough that they don't dial the next name.",
  },
  {
    label: "Setup",
    big: "45 minutes",
    body: "At your shop. I come to you, set up the call forwarding, and we test it together before I leave.",
  },
  {
    label: "Time to live",
    big: "About a week",
    body: "Most of that is the phone carriers approving the texting number. I do that part.",
  },
  {
    label: "The honest catch",
    big: "Landlines can't text",
    body: "A caller on a landline, or with their number hidden, can't receive a text. Those still go to voicemail — same as today.",
    wide: true,
  },
];

export const WhatChanges = () => (
  <section className="border-t-2 border-line bg-surface" data-testid="what-changes-section">
    <div className="mx-auto max-w-6xl px-4 py-20 sm:px-6 sm:py-28">
      <Reveal>
        <Eyebrow>Straight answers</Eyebrow>
        <h2 className="mt-4 font-display text-3xl font-bold uppercase leading-none tracking-tight sm:text-4xl md:text-5xl">
          What changes at your shop
        </h2>
      </Reveal>
      <div className="mt-14 grid gap-6 md:grid-cols-2 md:gap-8" data-testid="changes-grid">
        {ITEMS.map((item, i) => (
          <Reveal key={item.label} delay={(i % 2) * 0.08} className={item.wide ? "md:col-span-2" : ""}>
            <div className="h-full border-2 border-line bg-asphalt p-6 sm:p-8">
              <p className="font-mono text-xs font-semibold uppercase tracking-[0.25em] text-smoke">
                {item.label}
              </p>
              <p className="mt-3 font-display text-3xl font-bold uppercase leading-none tracking-tight text-safety sm:text-4xl">
                {item.big}
              </p>
              <p className="mt-4 max-w-2xl text-base leading-relaxed text-gray-300 sm:text-lg">
                {item.body}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
